import { useState, useEffect } from 'react';
import AppModal from './AppModal';

let _trigger = null;

export function confirmDialog(options) {
    _trigger?.(options);
}

export function ConfirmDialog() {
    const [opts, setOpts] = useState(null);

    useEffect(() => {
        _trigger = setOpts;
        return () => { if (_trigger === setOpts) _trigger = null; };
    }, []);

    const close = () => setOpts(null);
    const accept = () => { close(); opts?.accept?.(); };
    const reject = () => { close(); opts?.reject?.(); };

    return (
        <AppModal
            visible={!!opts}
            onHide={reject}
            panelStyle={{ width: '30rem', maxWidth: '95vw' }}
            zIndex={1400}
            header={opts?.header || 'Confirmation'}
        >
            {opts && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                        {opts.icon && (
                            <i className={opts.icon} style={{ fontSize: '1.5rem', color: '#f59e0b', marginTop: '2px', flexShrink: 0 }} />
                        )}
                        <div style={{ color: '#d1d1d6', lineHeight: 1.5, fontSize: '0.9rem' }}>{opts.message}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
                        <button
                            onClick={reject}
                            style={{ padding: '0.5rem 1.25rem', background: 'transparent', border: '1px solid #3a3a40', borderRadius: '8px', color: '#a0a0ab', cursor: 'pointer', fontSize: '0.875rem' }}
                        >
                            {opts.rejectLabel || 'No'}
                        </button>
                        <button
                            onClick={accept}
                            style={{ padding: '0.5rem 1.25rem', background: '#da474e', border: 'none', borderRadius: '8px', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600 }}
                        >
                            {opts.acceptLabel || 'Yes'}
                        </button>
                    </div>
                </div>
            )}
        </AppModal>
    );
}
